import AbstractAction from "../AbstractAction";

export default class ReshapeEllipseAction extends AbstractAction {
    constructor(provider, elementPart) {
        super(provider);

        this.elementPart = elementPart;
        this.parent = elementPart.parent;
        this.oldSize = this.parent.size;
        this.oldCanopyPoints = this.parent.canopyPoints;
    }

    update() {
        this.elementPart.move();
    }

    finish() {
        this.newSize = this.parent.size;
        if (this.oldSize == this.newSize) {
            super.discard();
        } else {
            this.parent.generateCanopyPoints();
            this.newCanopyPoints = this.parent.canopyPoints;
            super.finish();
        }
    }

    undo() {
        this.parent.size = this.oldSize;
        this.parent.canopyPoints = this.oldCanopyPoints;
        if (this.selection.length == 1 && this.selection.first == this.parent) {
            this.getTab('info').input.size.value(this.calculatePixelToDisplayDistance(this.parent.size));
        }
    }

    redo() {
        this.parent.size = this.newSize;
        this.parent.canopyPoints = this.newCanopyPoints;
        if (this.selection.length == 1 && this.selection.first == this.parent) {
            this.getTab('info').input.size.value(this.calculatePixelToDisplayDistance(this.parent.size));
        }
    }
}
